var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('portal-dialog',{attrs:{"id":"back"}},[_c('div',{staticClass:"back-dialog"},[_c('div',{staticClass:"content"}),_c('div',{staticClass:"desc"},[_vm._v(_vm._s(_vm.desc))]),_c('div',{staticClass:"btn",on:{"click":_vm.back}})])])}
var staticRenderFns = []

export { render, staticRenderFns }